import { useEffect, useState } from 'react';
import { getUnixTime } from 'date-fns';
import useSavedSessions from '../useSavedSessions';

const useSavedSessionFilters = ({ eventCode, activeDay }) => {
    const { savedSessions } = useSavedSessions();
    const [filters, setFilters] = useState('');

    useEffect(() => {
        if (!savedSessions) {
            return;
        }

        const nonNullSessions = savedSessions.filter((session) => !!session);

        const getSavedSessionFilter = () => {
            if (nonNullSessions.length === 0) {
                return 'objectID:NOT-A-SESSION';
            }

            return `(${nonNullSessions.map((c) => `objectID:"session-${c.recordId}"`).join(' OR ')})`;
        };

        const getDateRangeFilters = () => {
            const day = activeDay.getDate();
            const month = activeDay.getMonth();
            const year = activeDay.getFullYear();
            const dayStartUnix = getUnixTime(new Date(year, month, day));
            const dayEndUnix = getUnixTime(new Date(year, month, day + 1));

            return [`session_start_time >= ${dayStartUnix}`, `session_start_time < ${dayEndUnix}`];
        };

        const filterArray = [
            'content_type:session',
            `event.event_code:${eventCode}`,
            getSavedSessionFilter(),
            ...getDateRangeFilters(),
        ];

        setFilters(filterArray.join(' AND '));
    }, [eventCode, activeDay, savedSessions]);

    return { filters };
};

export default useSavedSessionFilters;
